import {combineEpics} from 'redux-observable';
import sagaEpic from "./sagaEpic";

export const rootEpic = combineEpics(
    sagaEpic
);
